import { callGet, callPost, callPostForBlob } from '../../services/axios'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import axios from 'axios'
import { getChildSuppliersByIds } from './vendor'

export const getAllListSupplierInfo = ({ listSupplierId, vendorInCallsDetailsId, supplierId = null, isInCalls = true }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/caller/getAllListSupplierInfo`, token, {
        listSupplierId,
        vendorInCallsDetailsId,
        supplierId,
        isInCalls
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getAllListSupplierNotInCalls = ({ listId, limit, offset, sortColumn, sortType, isShowAllSuppliers, filterData }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    filterData = JSON?.stringify(filterData)
    return callGet(`/api/caller/getAllListSupplierNotInCalls`, token, {
        listId,
        limit,
        offset,
        sortColumn,
        sortType,
        isShowAllSuppliers,
        filterData
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getMatchedSuppliersInSendToCalls = ({ listId, limit, offset, sortColumn, sortType, isShowAllSuppliers, filterData, selectedCompanyStatus }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    filterData = JSON?.stringify(filterData)
    return callGet(`/api/caller/getMatchedSuppliersInSendToCalls`, token, {
        listId,
        limit,
        offset,
        sortColumn,
        sortType,
        isShowAllSuppliers,
        filterData,
        selectedCompanyStatus
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getUnMatchedSupplierInSendToCalls = ({ listId, limit, offset, sortColumn, sortType, isShowAllSuppliers, filterData, selectedCompanyStatus }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    filterData = JSON?.stringify(filterData)
    return callGet(`/api/caller/getUnMatchedSupplierInSendToCalls`, token, {
        listId,
        limit,
        offset,
        sortColumn,
        sortType,
        isShowAllSuppliers,
        filterData,
        selectedCompanyStatus
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getAllMatchedListSupplierNotInCalls = ({ listId, isShowAllSuppliers, filterData, limit, offset }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    filterData = JSON?.stringify(filterData)
    return callGet(`/api/caller/getAllMatchedListSupplierNotInCalls`, token, {
        listId,
        isShowAllSuppliers,
        filterData,
        limit,
        offset
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getAllRemainingListSuppliersIds = ({ listId, checkedKeys, isGetNotInCalls = false, isGetUnmatched = false, isGetAllSuppliers = false, isGetAcceptanceInfo = false, fromAutoCreateMasterModal = false }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getAllRemainingListSuppliersIds`, {
        listId,
        checkedIds: checkedKeys,
        isGetNotInCalls,
        isGetUnmatched,
        isGetAllSuppliers,
        isGetAcceptanceInfo,
        fromAutoCreateMasterModal
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const sendListSuppliersToCalls = ({ suppliersData = [], isPausedSequencing = false, isReenablement = false }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/sendListSuppliersToCalls`, {
        suppliersData: suppliersData,
        isPausedSequencing,
        isReenablement
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: 'List Suppliers Send to Calls Successfully!',
            duration: 1000
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to Send to Calls!',
            duration: 1000
        })
        return Promise.reject(err)
    })
}

export const updateListSuppliersInCalls = ({ listSuppliers = null, supplierData = null }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateListSuppliersInCalls`, {
        listSuppliers: listSuppliers,
        supplierData
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: 'List Suppliers in Calls updated Successfully!',
            duration: 1000
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to update in calls suppliers!',
            duration: 1000
        })
        return Promise.reject(err)
    })
}

export const updateReasonToNotCallPerVendor = ({ listSuppliers }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateReasonToNotCallPerVendor`, {
        listSuppliers: listSuppliers
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: 'List Suppliers in Calls updated Successfully!',
            duration: 1000
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to update in calls suppliers!',
            duration: 1000
        })
        return Promise.reject(err)
    })
}


export const deleteReasonToNotCallPerVendor = ({ listSupplierIds }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/deleteReasonToNotCallPerVendor`, {
        listSupplierIds: listSupplierIds
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: 'List Suppliers in Calls remove Successfully!',
            duration: 1000
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to remove in calls suppliers!',
            duration: 1000
        })
        return Promise.reject(err)
    })
}

export const deleteListSuppliersInCalls = ({ listSupplierIds = null, supplierIds = null }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/deleteListSuppliersInCalls`, {
        listSupplierIds: listSupplierIds,
        supplierIds
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: 'List Suppliers in Calls remove Successfully!',
            duration: 1000
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to remove in calls suppliers!',
            duration: 1000
        })
        return Promise.reject(err)
    })
}

export const listSuppliersAddReasonToNotCall = ({ listSuppliers }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/listSuppliersAddReasonToNotCall`, {
        listSuppliers: listSuppliers
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: 'Reason to Not Call added successfully!'
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to add Reason To Not Call!'
        })
        return Promise.reject(err)
    })
}

export const getInCallsListSuppliers = (sequenceFilters, userId) => (dispatch, getState) => {
    const { auth: { token, user } } = getState()
    const { assignedPhoneNumber: phoneNumber } = user

    let filterData = JSON?.stringify(sequenceFilters)
    return callGet(`/api/caller/getInCallsListSuppliers`, token, { filterData, userId, phoneNumber }).then((res) => {
        const listSuppliersInCalls = res['data']?.listSuppliersInCalls
        let result = []

        if (listSuppliersInCalls && listSuppliersInCalls?.length > 0) {
            const lists = res['data']?.lists
            const partners = res['data']?.partners

            result = listSuppliersInCalls?.map((data) => {
                const list = lists.find(l => l.id === data?.listId) || {}
                const partner = partners.find(p => p?.id === list?.partnerId) || null

                return {
                    ...data,
                    id: data.listSupplierId,
                    vendorsInCall: data,
                    list: {
                        companyName: list.companyName || '',
                        dateSubmitted: list.dateSubmitted || '',
                        nameUse: list.nameUse || false,
                        partner: {
                            partnerName: partner?.partnerName || ''
                        }
                    },
                }
            })
        }
        return Promise.resolve(result)
    }).catch(err => {
        console.log("incalls err", err)
        return Promise.reject(err)
    })
}

export const holdCall = (callerId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/holdCall`, { callerId }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}
export const unholdCall = () => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/unholdCall`, {}, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const matchInboundCaller = (phoneNumbers) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/matchInboundCaller`, { phoneNumbers }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const addVendorInCallsDetails = ({ callDetails }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/addVendorInCallsDetails`, { callDetails }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const addListSupplierHistory = (historyData, showToast = true) => (dispatch, getState) => {
    const { auth: { user, token } } = getState()
    var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
    const { id } = user
    const { listSupplierId, note, noteType, supplierName, vendorInCallsDetailsId, isInCalls, supplierId, createdFrom = null } = historyData
    var regex = /<a .*?>/g
    const emailsArray = [...note.matchAll(regex)]
    var emails = []
    emailsArray && emailsArray.map((item) => {
        var hrefRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g
        var valueRegex = /<a\s+(?:[^>]*?\s+)?data-value="([^"]*)"/g
        const hrefArray = [...item[0].matchAll(hrefRegex)]
        const valueArray = [...item[0].matchAll(valueRegex)]
        if (hrefArray.length && valueArray.length) {
            const href = hrefArray?.[0]?.[1]
            const value = valueArray?.[0]?.[1]
            emails.push({ email: href.replaceAll('https://', ''), name: value.replaceAll('https://', '') })
        }
    })
    return callPost(`/api/caller/addListSupplierHistory`, {
        listSupplierId,
        userId: id,
        note,
        noteType,
        userName,
        supplierName,
        emails,
        vendorInCallsDetailsId,
        isInCalls,
        supplierId,
        createdFrom
    }, token).then((res) => {
        if (showToast) {
            toast.show({
                title: 'Success',
                description: 'Successfully added notes data!'
            })
        }
        return Promise.resolve(res?.data)
    }).catch(() => {
        if (showToast) {
            toast.show({
                title: 'Warning',
                description: 'Failed to add notes data!',
            })
        }
    })
}

export const createSupplierBasicInfo = (basicInfo, listSupplierId, vendorInCallsDetailsId = null, cardId = null, paymentId = null) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/createSupplierBasicInfo`, {
        basicInfo,
        listSupplierId,
        vendorInCallsDetailsId,
        cardId,
        paymentId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateSupplierBasicInfo = (basicInfo, listSupplierId, vendorInCallsDetailsId, supplierId = null) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateSupplierBasicInfo`, {
        basicInfo,
        listSupplierId,
        vendorInCallsDetailsId,
        supplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const createSupplierCardInfo = (cardData, feeData, listSupplierId, vendorInCallsDetailsId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/createSupplierCardInfo`, {
        cardData,
        feeData,
        listSupplierId,
        vendorInCallsDetailsId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateSupplierCardInfo = (cardData, feeData, listSupplierId, cardId, vendorInCallsDetailsId, supplierId = null) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateSupplierCardInfo`, {
        cardData,
        feeData,
        cardId,
        listSupplierId,
        vendorInCallsDetailsId,
        supplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const createSupplierPaymentInfo = (paymentInfo, listSupplierId, vendorInCallsDetailsId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/createSupplierPaymentInfo`, {
        paymentInfo,
        listSupplierId,
        vendorInCallsDetailsId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateSupplierPaymentInfo = (paymentInfo, paymentId, vendorInCallsDetailsId, supplierId = null) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateSupplierPaymentInfo`, {
        paymentInfo,
        paymentId,
        vendorInCallsDetailsId,
        supplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateVendorInCallsById = ({ vendorInCallsData, vendorInCallsId, vendorInCallsDetails }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateVendorInCallsById`, {
        vendorInCallsData,
        vendorInCallsId,
        vendorInCallsDetailsData: vendorInCallsDetails
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateVendorInCallsDetailsById = ({ vendorInCallsDetailsId, vendorInCallsDetails }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateVendorInCallsDetailsById`, {
        vendorInCallsDetails,
        vendorInCallsDetailsId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const approveCallerDetails = ({ listSupplierData, masterId, listId, listSupplierId, note, matchedSupplierId }) => (dispatch, getState) => {
    const { auth: { user, token }, domain: { currentDomain } } = getState()
    const { id: userId } = user
    const { id: domainId } = currentDomain
    delete listSupplierData?.histories
    delete listSupplierData?.id
    delete listSupplierData?.vendorsInCall

    return callPost(`/api/caller/approveCallerDetails`, {
        listSupplierData,
        masterId,
        listId,
        userId,
        domainId,
        listSupplierId,
        note,
        matchedSupplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const rejectCallerDetails = ({ listSupplierId, vendorInCallsData, vendorInCallsId, note, emailTo, callerName, isStopSequencing, supplierId, isForMatchedListSupplier }) => (dispatch, getState) => {
    const { auth: { token, user } } = getState()
    const { id: userId } = user
    return callPost(`/api/caller/rejectCallerDetails`, {
        vendorInCallsData,
        vendorInCallsId,
        note,
        emailTo,
        callerName,
        listSupplierId,
        userId,
        isStopSequencing,
        supplierId,
        isForMatchedListSupplier
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const linkCallerDetailsLater = ({ callDetails, vendorInCallsDetails }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/linkCallerDetailsLater`, {
        callDetails,
        vendorInCallsDetails
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getUnlinkedCalls = (userId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/caller/getUnlinkedCalls`, token, { userId }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}


export const getStatesToNotRecordCalls = () => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/caller/getStatesToNotRecordCalls`, token, {}).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const addStateToNotRecordCalls = (stateData) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/addStateToNotRecordCalls`, {
        stateData
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const removeStateToNotRecordCalls = (id) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/removeStateToNotRecordCalls`, {
        id
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const removeUnlinkedCallDetails = (vendorsInCallsId, vendorsInCallsDetailsId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/removeUnlinkedCallDetails`, {
        vendorsInCallsId,
        vendorsInCallsDetailsId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const linkUnlinkedCallToVendor = (vendorId, vendorsInCallsId, vendorsInCallsDetailsId, callsAttempted) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/linkUnlinkedCallToVendor`, {
        vendorId,
        vendorsInCallsId,
        vendorsInCallsDetailsId,
        callsAttempted
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const createCallRecord = (callData) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/createCallRecord`, {
        callData
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateCallRecord = (callData, callId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateCallRecord`, {
        callData,
        callId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const addCallDetails = (callData) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/addCallDetails`, {
        callData
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateCallDetails = (callData, callSid) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateCallDetails`, {
        callData,
        callSid
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getRecentCallsAndVoicemails = (callerAssigned) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getRecentCallsAndVoicemails`, { callerAssigned }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const linkVoicemailToVendor = (vendorId, callSid, listSupplierId) => (dispatch, getState) => {
    const { auth: { token, user } } = getState()
    const { id } = user
    return callPost(`/api/caller/linkVoicemailToVendor`, {
        vendorId,
        callSid,
        listSupplierId,
        userId: id
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const shareCall = (note, userName, emails, callId, vendorId, isVoicemail = false, page) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/shareCall`, {
        note,
        userName,
        emails,
        callId,
        vendorId,
        isVoicemail,
        page
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: res?.data
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: err?.data
        })
        return Promise.reject(err)
    })
}

export const createCallingScript = (payload) => (dispatch, getState) => {
    const { auth: { token } } = getState();
    return callPost(`/api/caller/createCallingScript`, payload, token)
        .then(res => res.data)
        .catch(err => {
            console.error('API Error:', err);
            throw err;
        });
};



export const getCallingScriptsByPartnerId = (partnerId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/caller/getCallingScriptsByPartnerId`, token, { partnerId }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const changeListSuppliersCallingScript = ({ listSuppliers }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/changeListSuppliersCallingScript`, {
        listSuppliers: listSuppliers
    }, token).then((res) => {
        toast.show({
            title: 'Success',
            description: res?.data?.message,
            duration: 1000
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to change calling scripts!',
            duration: 1000
        })
        return Promise.reject(err)
    })
}

export const getTwilioPhoneNumbers = (partnerId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/caller/getTwilioPhoneNumbers`, token, {}).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const updateListMasterGlobalAcceptance = (isGlobalAcceptance, cardId, listSupplierId, vendorInCallsDetailsId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateListMasterGlobalAcceptance`, {
        isGlobalAcceptance,
        cardId,
        listSupplierId,
        vendorInCallsDetailsId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getCallerScriptsOfPartner = (partnerId = null) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet("/api/caller/getCallingScriptsForPartner", token, { partnerId }).then((res) => {
        return Promise.resolve(res?.data?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const deleteCallerScriptOfPartner = (partnerId, scriptId) => (dispatch, getState) => {
    const { auth: { token } } = getState();
    return callPost("/api/caller/deleteCallerScriptForPartner", {
        partnerId,
        scriptId
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const editCallerScriptOfPartner = (partnerId, scriptId, isChangeDefaultScript, scriptDetails, isDefaultId) => (dispatch, getState) => {
    const { auth: { token } } = getState();

    return callPost("/api/caller/editCallerScriptForPartner", {
        partnerId,
        scriptId,
        isChangeDefaultScript,
        scriptDetails,
        isDefaultId
    }, token).then((res) => {
        return Promise.resolve(res.data);
    }).catch((err) => {
        return Promise.reject(err);
    });
};

export const createAutoMastersForListSuppliers = (listSupplier) => (dispatch, getState) => {
    const { auth: { user, token } } = getState()
    const { id } = user
    return callPost(`/api/caller/createAutoMastersForListSuppliers`, {
        listSupplier,
        userId: id
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getCallRecordings = (listSupplierId = null, vendorInCallsDetailsId = null, supplierId = null) => async (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet('/api/caller/getCallRecordings', token, {
        listSupplierId,
        vendorInCallsDetailsId,
        supplierId
    }
    ).then(res => {
        return Promise.resolve(res['data']?.callRecordings || [])
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get call recordings!'
        })
        return Promise.reject({ err })
    })
}

export const updateListSupplierDetails = ({ supplierId, listSupplierId, masterId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateListSupplierDetails`, {
        supplierId,
        listSupplierId,
        masterId
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const updateListMasterSupplierDetails = ({ masterId, listSupplierId, note, updateQaStatus = true, isUpdateAccDate = true }) => (dispatch, getState) => {
    const { auth: { user, token } } = getState()
    const { id: userId } = user
    return callPost(`/api/caller/updateListMasterSupplierDetails`, {
        masterId,
        listSupplierId,
        userId,
        note,
        updateQaStatus,
        isUpdateAccDate
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const removeUnlinkedSupplierCallDetails = (vendorsInCallsDetailsId, isRemoveHistory = false) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/removeUnlinkedSupplierCallDetails`, {
        vendorsInCallsDetailsId,
        isRemoveHistory
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const updateUnlinkedCallSupplierDetails = (listSupplierId, vendorsInCallsDetailsId, vendorsInCallsId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateUnlinkedCallSupplierDetails`, {
        listSupplierId,
        vendorsInCallsDetailsId,
        vendorsInCallsId
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getVoicemails = () => async (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet('/api/caller/getVoicemails', token, {}
    ).then(res => {
        return Promise.resolve(res['data']?.voicemails || [])
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get voicemails!'
        })
        return Promise.reject({ err })
    })
}

export const updateMasterSupplierQAStatus = (masterIds, qaStatus) => async (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost('/api/caller/updateMasterSupplierQAStatus', {
        masterIds,
        qaStatus
    }, token).then(res => {
        toast.show({
            title: 'Success',
            description: res?.data?.message
        })
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: err?.data?.message
        })
    })
}

export const removeListSupplierFromCall = (listSupplierId) => async (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost('/api/caller/removeListSupplierFromCall', {
        listSupplierId
    }, token).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        return Promise.reject({ err })
    })
}

// get contact name score by checking contact name for latest successfull enablement
export const getContactNameForSuccessfulEnablement = (masterId) => (dispatch, getState) => {
    const { auth: { token } } = getState()

    return callGet(`/api/caller/getContactNameForSuccessfulEnablement`, token, {
        masterId
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject({ err })
    })
}

export const addContactNameForCall = (contactName = '', callId = null, contactId = null) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/addContactNameForCall`, {
        contactName,
        callId,
        contactId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const linkContactNameForAllCalls = ({ contactName = '', contactId = null, vendorInCallsDetailsId = null, isRefusedToProvideName = false }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/linkContactNameForAllCalls`, {
        contactName,
        contactId,
        vendorInCallsDetailsId,
        isRefusedToProvideName
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const createMasterSupplierBasicInfo = (basicInfo, cardInfo, paymentInfo, matchedSupplierId = null, feeData) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/createMasterSupplierBasicInfo`, {
        basicInfo,
        cardInfo,
        paymentInfo,
        matchedSupplierId,
        feeData
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateMasterSupplierBasicInfo = (basicInfo, matchedSupplierId = null, listSupplierId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateMasterSupplierBasicInfo`, {
        basicInfo,
        matchedSupplierId,
        listSupplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getNewMasterListSupplierInfo = ({ matchedSupplierId = null }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/caller/getNewMasterListSupplierInfo`, token, {
        matchedSupplierId
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const updateNewMasterSupplierCardInfo = (cardData, listSupplierId, feeData) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateNewMasterSupplierCardInfo`, {
        cardData,
        listSupplierId,
        feeData
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateNewMasterSupplierPaymentInfo = (paymentInfo, listSupplierId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateNewMasterSupplierPaymentInfo`, {
        paymentInfo,
        listSupplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}


export const updateCallerForLsInSequence = ({ callerId, listSupplierId = null, supplierId = null }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateCallerForLsInSequence`, {
        callerId, listSupplierId, supplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}


export const getCallers = () => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/caller/getCallers`, token, {}).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getMasterCreatedFromCalls = (listSupplierIds) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getMasterCreatedFromCalls`, { listSupplierIds }, token,).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updatelastEmailSentDate = (vendorInCallDetailsId) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updatelastEmailSentDate`, { vendorInCallDetailsId }, token,).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const linkNewMatchedSupplierInfo = (matchedSupplierId, isUpdateAccDate) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/linkNewMatchedSupplierInfo`, {
        matchedSupplierId,
        isUpdateAccDate
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getReenablementSuppliers = ({ limit, offset, sortColumn, sortType, isShowAllSuppliers = false, filterData = {} }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    filterData = JSON.stringify(filterData)

    return callPost(`/api/caller/getReenablementSuppliers`, {
        limit,
        offset,
        sortColumn,
        sortType,
        isShowAllSuppliers,
        filterData
    }, token).then(async (res) => {
        const reenablementSuppliers = res?.data?.suppliers
        const cardAcceptanceData = res?.data?.cardAcceptanceData
        const masterSuppliers = res?.data?.masterSuppliers
        const supplierIds = reenablementSuppliers?.map(sup => sup?.id)
        let tmpSuppliers = []
        if (reenablementSuppliers && reenablementSuppliers?.length > 0) {
            const childSuppliersData = await getChildSuppliersData(supplierIds, dispatch)
            tmpSuppliers = reenablementSuppliers?.map(supplier => {
                var masterSupplierName = ''
                const cardAcc = cardAcceptanceData?.find(data => data?.supplierId === supplier?.id)
                const childSuppliers = childSuppliersData?.filter(sup => sup?.masterId === supplier?.id || sup?.primaryMasterId === supplier?.id)
                const { supplierId, isAcceptAmericanExpress, isAcceptMasterCard, isAcceptVisa } = cardAcc;
                const cardValues = [isAcceptAmericanExpress, isAcceptMasterCard, isAcceptVisa];
                let acceptsCard = 'Unknown';

                if (cardValues.every(value => value === null)) {
                    acceptsCard = 'Unknown';
                } else if (cardValues.some(value => value === true)) {
                    acceptsCard = 'Yes';
                } else if (cardValues.every(value => value === false)) {
                    acceptsCard = 'No';
                }

                if (masterSuppliers?.length > 0) {
                    masterSupplierName = masterSuppliers?.find(sup => sup?.id === supplier?.masterId)?.suppliername
                }
                var supplierData = { ...supplier, ...supplier?.supplierDetail, ...supplier?.vendorsInCall, ...cardAcc }
                supplierData['acceptsCard'] = acceptsCard
                supplierData['childSupplierCount'] = childSuppliers?.length || 0
                supplierData['masterSupplierName'] = masterSupplierName || ''
                return supplierData
            })
        }
        return Promise.resolve({ reenablementSuppliers: tmpSuppliers, total: res?.data?.total })
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const updateCallerForSupplierReenablement = ({ callerId, supplierId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/updateCallerForSupplierReenablement`, {
        callerId, supplierId
    }, token).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const createTranscriptions = (callSid, recordingSid) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/createTranscriptions`, { callSid, recordingSid }, token,).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getAllRemainingReenablementSuppliersIds = ({ isGetNotInCalls }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getAllRemainingReenablementSuppliersIds`, {
        isGetNotInCalls
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

const getChildSuppliersData = async (masterIds, dispatch, isLocationMaster = false) => {
    const data = await dispatch(getChildSuppliersByIds({ isLocationMaster, masterIds })).then(res => {
        return res
    })
    return data
}

export const getSupplierCallDetailsById = ({ supplierId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getSupplierCallDetailsById`, {
        supplierId
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getTranscriptionSentences = (transcriptionSid) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getTranscriptionSentences`, { transcriptionSid }, token,).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const autoCreateMasterChildSupplierWorker = ({ listSupplierIds, domainId, listId, listUploadUserId }) => (dispatch, getState) => {
    const { auth: { user, token } } = getState()
    const { id } = user
    return callPost(`/api/caller/autoCreateMasterChildSupplierWorker`, {
        listSupplierIds,
        userId: id,
        domainId,
        listId,
        listUploadUserId,
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getMediaData = (callTranscriptionSid) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getMediaData`, { callTranscriptionSid }, token,).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}


export const getSentenceData = (callTranscriptionSid) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getSentenceData`, { callTranscriptionSid }, token,).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getRecordingUrl = (callRecordingSid) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPostForBlob(`/api/caller/getRecordingUrl`, {callRecordingSid}, token,).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}

export const getListSuppliersByIds = (listSupplierIds) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/caller/getListSuppliersByIds`, { listSupplierIds }, token, {}).then((res) => {
        return Promise.resolve(res?.data)
    }).catch((err) => {
        return Promise.reject(err)
    })
}